import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import { rulesDetailsAtom } from '@/pages/Administration/AdministrationRules';

import useStyles from './RulesFileContent.styles';

const RulesFileContent = () => {
  const [rulesDetails] = useAtom(rulesDetailsAtom);
  const { classes } = useStyles();

  const fileContent = useMemo(() => {
    if (rulesDetails) {
      // note: empty files can be uploaded when updating - not when creating
      if (rulesDetails.preview === 'This file is empty') {
        return '[Empty File]';
      }
      return rulesDetails.preview;
    }
    return null;
  }, [rulesDetails]);

  return (
    <Typography className={classes.rulesFileContent} component="pre">
      {fileContent}
    </Typography>
  );
};

export default RulesFileContent;
